import React, { Component } from "react";
import axios from "axios";
import ImageGallery from "react-image-gallery";
import { Container, Row, Col } from "react-grid-system";
import * as Icon from "react-feather";
import { translate } from "ra-core";
import Avatar from "react-avatar";

class Preview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      starnameid: props.match.params.starnameId,
      namecard: {
        addr: "",
        company: "",
        department: "",
        email: "",
        fax: "",
        homepage: "",
        idx: "",
        img_background: 12,
        img_namecard: "",
        img_logo: "",
        mobile: "",
        name: "",
        position: "",
        tel: "",
      },
      info: {
        qrId: 0,
        qrkey: "",
        userId: 0,
        cgroup: "starname",
      },
      buttons: [],
      slideimages: [],
      simages: [],

      showVideo: {},
      showGalleryPlayButton: true,
    };
  }

  componentDidMount() {
    this.getQrcodeInfo(this.state.starnameid);
  }

  getQrcodeInfo(qrkey) {
    console.log(qrkey);
    axios
      .post("https://happyqr.net/api/starname/api/getQrcodeInfo", {
        qrkey: qrkey,
      })
      .then((data) => {
        if (data.data.code == 200) {
          console.log(data.data);
          this.setState({
            namecard: data.data.namecard,
            info: data.data.info,
            buttons: data.data.buttons,
            slideimages: JSON.parse(data.data.info.images),
          });

          const images = [];
          const pro_images = JSON.parse(data.data.info.images);
          pro_images.map((item) => {
            if (item.search("youtu") == -1)
              images.push({
                original: item,
                renderItem: this._renderImage.bind(this),
              });
            else
              images.push({
                originalurl: item,
                original:
                  "https://img.youtube.com/vi/" +
                  item.replace("https://youtu.be/", "") +
                  "/0.jpg",
                renderItem: this._renderYouTubeThumb.bind(this),
              });
          });
          console.log(images);
          this.setState({ simages: images });
        }
      })
      .catch((error) => {
        console.log("error : ", error);
      });
  }

  _onSlide(index) {
    this._resetVideo();
    console.debug("slid to index", index);
  }

  _resetVideo() {
    this.setState({ showVideo: {} });

    if (this.state.showPlayButton) {
      this.setState({ showGalleryPlayButton: true });
    }

    if (this.state.showFullscreenButton) {
      this.setState({ showGalleryFullscreenButton: true });
    }

    var video = document.getElementsByClassName("yvideo");
    console.log(video.item);
    for (var i = 0; i < video.length; i++) {
      video
        .item(i)
        .contentWindow.postMessage(
          '{"event":"command","func":"stopVideo","args":""}',
          "*"
        );
    }
  }

  _toggleShowVideo(url) {
    this.state.showVideo[url] = !Boolean(this.state.showVideo[url]);
    this.setState({
      showVideo: this.state.showVideo,
    });

    if (this.state.showVideo[url]) {
      if (this.state.showPlayButton) {
        this.setState({ showGalleryPlayButton: false });
      }

      if (this.state.showFullscreenButton) {
        this.setState({ showGalleryFullscreenButton: false });
      }
    }
  }

  _renderImage(item) {
    return <img src={item.original} />;
  }

  _renderYouTubeThumb(item) {
    const x = -50;
    const y = -50;
    const bstyles = {
      transform: `translate(${x}%, ${y}%)`,
      top: "50%",
      left: "50%",
      width: "80px",
      height: "auto",
      position: "absolute",
    };

    const imageClick = () => {
      console.log(this.state.info.userId);
      window.open(item.originalurl);
    };

    return (
      <div style={{ position: "relative" }}>
        <img style={{ width: "100%", height: "auto" }} src={item.original} />
        <img
          style={bstyles}
          onClick={() => imageClick()}
          src={"/youtube_play.png"}
        />
      </div>
    );
  }

  _renderVideo(item) {
    return (
      <div className="image-gallery-image">
        {
          <div className="video-wrapper">
            <iframe
              className="yvideo"
              width="560"
              height="315"
              src={item.embedUrl}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        }
      </div>
    );
  }

  renderHeader() {
    if (this.state.info.cgroup == "realvote") {
      return (
        <img
          src={"/realvote_logowithtext.png"}
          style={{ height: "30px", backgroundSize: "contain" }}
        ></img>
      );
    } else {
      return (
        <img
          src={"/mainlogo.png"}
          style={{ height: "30px", backgroundSize: "contain" }}
        ></img>
      );
    }
  }

  renderDepPos(department, position) {
    let vstring = "";
    if (department != null && department.length > 0) {
      vstring += department;
    }

    if (vstring.length > 0) vstring += " / ";

    if (position != null && position.length > 0) {
      vstring += position;
    }

    return <div style={{ height: "18px" }}>{vstring}</div>;
  }

  renderNameCard() {
    const info = this.state.namecard;
    if (info.img_namecard != null && info.img_namecard.length > 0) {
      return (
        <div style={{ backgroundSize: "cover", backgroundColor: "white" }}>
          <img
            src={info.img_namecard}
            style={{ width: "100%", height: "100%", backgroundSize: "cover" }}
          ></img>
        </div>
      );
    }
    return (
      <div style={{ backgroundSize: "cover", backgroundColor: "white" }}>
        {/** namecard top viewer */}
        <div
          style={{
            height: "60px",
            paddingLeft: "5%",
            paddingRight: "5%",
            paddingBottom: "5%",
            paddingTop: "2%",
          }}
        >
          <div
            style={{
              width: "30%",
              height: "70px",
              float: "left",
              textAlign: "left",
            }}
          >
            {info.img_logo.length > 0 ? (
              <Avatar src={info.img_logo} round={true} size="60"></Avatar>
            ) : (
              <Avatar src="/default_avatar.png" round={true} size="60"></Avatar>
            )}
          </div>

          <div style={{ width: "70%", height: "70px", float: "right" }}>
            <div style={{ height: "20px" }}>{info.company}</div>
            <div style={{ height: "20px" }}>{info.name}</div>
            {this.renderDepPos(info.department, info.position)}
          </div>
        </div>
        {/** namecard top viewer */}

        {/** namecard bottom viewer */}
        <table style={{ marginLeft: "5%", marginBottom: 5, width: "100%" }}>
          <tr>
            <td>
              M.{" "}
              {info.mobile.replace(
                /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
                "$1-$2-$3"
              )}
            </td>
            <td>
              T.{" "}
              {info.tel.replace(
                /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
                "$1-$2-$3"
              )}
            </td>
          </tr>
          <tr>
            <td colspan="2">E. {info.email}</td>
          </tr>
          <tr>
            <td colspan="2">A. {info.addr}</td>
          </tr>
          <tr>
            <td colspan="2">H. {info.homepage}</td>
          </tr>
        </table>
      </div>
    );
  }

  renderImages() {
    return (
      <ImageGallery
        items={this.state.simages}
        showThumbnails={false}
        showPlayButton={false}
        showFullscreenButton={false}
        showNav={true}
        onSlide={this._onSlide.bind(this)}
      />
    );
  }

  renderGotoReg() {
    const imageClick = () => {
      console.log(this.state.info.userId);
      window.open("/Event01/" + this.state.info.userId);
    };
    return <img src="/event01.png" onClick={() => imageClick()} />;
  }

  renderButtons() {
    const pro_buttons = this.state.buttons;

    let count = 0;
    let button01 = [];
    let button02 = [];
    let button03 = [];

    pro_buttons.map((item) => {
      if (count < 5) button01.push(item);
      else if (count < 10) button02.push(item);
      else button03.push(item);
      count++;
    });

    if (button03.length > 0) {
      return (
        <div>
          <Row style={{ width: "100%", marginLeft: 0, marginRight: 0 }}>
            {button01.map((item, index) => (
              <Col
                onClick={() => {
                  if (item.value.length > 0) {
                    if (item.type == "link" || item.type == "file") {
                      if (item.value.startsWith("http"))
                        window.open(item.value);
                      else window.open("http://" + item.value);
                    } else if (item.type == "tel") {
                      window.location.href = "tel:" + item.value;
                    } else if (item.type == "sms") {
                      window.location.href = "sms:" + item.value;
                    } else if (item.type == "mailto") {
                      window.location.href = "mailto:" + item.value;
                    } else if (item.type == "alert") {
                      alert(item.value);
                    }
                  }
                }}
                style={{
                  backgroundColor: "white",
                  textAlign: "center",
                  border: "0.02px solid black",
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
              >
                {this.renderButtonIcon(item.icon)}
                <div style={{ color: "#000", fontSize: 10 }}>{item.title}</div>
              </Col>
            ))}
          </Row>

          <Row style={{ width: "100%", marginLeft: 0, marginRight: 0 }}>
            {button02.map((item, index) => (
              <Col
                onClick={() => {
                  if (item.value.length > 0) {
                    if (item.type == "link" || item.type == "file") {
                      if (item.value.startsWith("http"))
                        window.open(item.value);
                      else window.open("http://" + item.value);
                    } else if (item.type == "tel") {
                      window.location.href = "tel:" + item.value;
                    } else if (item.type == "sms") {
                      window.location.href = "sms:" + item.value;
                    } else if (item.type == "mailto") {
                      window.location.href = "mailto:" + item.value;
                    } else if (item.type == "alert") {
                      alert(item.value);
                    }
                  }
                }}
                style={{
                  backgroundColor: "white",
                  textAlign: "center",
                  border: "0.02px solid black",
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
              >
                {this.renderButtonIcon(item.icon)}
                <div style={{ color: "#000", fontSize: 10 }}>{item.title}</div>
              </Col>
            ))}
          </Row>
          <Row style={{ width: "100%", marginLeft: 0, marginRight: 0 }}>
            {button03.map((item, index) => (
              <Col
                onClick={() => {
                  if (item.value.length > 0) {
                    if (item.type == "link" || item.type == "file") {
                      if (item.value.startsWith("http"))
                        window.open(item.value);
                      else window.open("http://" + item.value);
                    } else if (item.type == "tel") {
                      window.location.href = "tel:" + item.value;
                    } else if (item.type == "sms") {
                      window.location.href = "sms:" + item.value;
                    } else if (item.type == "mailto") {
                      window.location.href = "mailto:" + item.value;
                    } else if (item.type == "alert") {
                      alert(item.value);
                    }
                  }
                }}
                style={{
                  backgroundColor: "white",
                  textAlign: "center",
                  border: "0.02px solid black",
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
              >
                {this.renderButtonIcon(item.icon)}
                <div style={{ color: "#000", fontSize: 10 }}>{item.title}</div>
              </Col>
            ))}
          </Row>
        </div>
      );
    } else {
      return (
        <div>
          <Row style={{ width: "100%", marginLeft: 0, marginRight: 0 }}>
            {button01.map((item, index) => (
              <Col
                onClick={() => {
                  if (item.value.length > 0) {
                    if (item.type == "link" || item.type == "file") {
                      if (item.value.startsWith("http"))
                        window.open(item.value);
                      else window.open("http://" + item.value);
                    } else if (item.type == "tel") {
                      window.location.href = "tel:" + item.value;
                    } else if (item.type == "sms") {
                      window.location.href = "sms:" + item.value;
                    } else if (item.type == "mailto") {
                      window.location.href = "mailto:" + item.value;
                    } else if (item.type == "alert") {
                      alert(item.value);
                    }
                  }
                }}
                style={{
                  backgroundColor: "white",
                  textAlign: "center",
                  border: "0.02px solid black",
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
              >
                {this.renderButtonIcon(item.icon)}
                <div style={{ color: "#000", fontSize: 10 }}>{item.title}</div>
              </Col>
            ))}
          </Row>

          <Row style={{ width: "100%", marginLeft: 0, marginRight: 0 }}>
            {button02.map((item, index) => (
              <Col
                onClick={() => {
                  if (item.value.length > 0) {
                    if (item.type == "link" || item.type == "file") {
                      if (item.value.startsWith("http"))
                        window.open(item.value);
                      else window.open("http://" + item.value);
                    } else if (item.type == "tel") {
                      window.location.href = "tel:" + item.value;
                    } else if (item.type == "sms") {
                      window.location.href = "sms:" + item.value;
                    } else if (item.type == "mailto") {
                      window.location.href = "mailto:" + item.value;
                    } else if (item.type == "alert") {
                      alert(item.value);
                    }
                  }
                }}
                style={{
                  backgroundColor: "white",
                  textAlign: "center",
                  border: "0.02px solid black",
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
              >
                {this.renderButtonIcon(item.icon)}
                <div style={{ color: "#000", fontSize: 10 }}>{item.title}</div>
              </Col>
            ))}
          </Row>
        </div>
      );
    }
  }

  renderButtonIcon(name) {
    switch (name) {
      case "home":
        return (
          <Icon.Home size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "phone":
        return (
          <Icon.Phone size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "aperture":
        return (
          <Icon.Aperture size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "shopping-bag":
        return (
          <Icon.ShoppingBag
            size={20}
            style={{ color: "ed1c24", marginTop: 5 }}
          />
        );
      case "facebook":
        return (
          <Icon.Facebook size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "instagram":
        return (
          <Icon.Instagram size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "send":
        return (
          <Icon.Send size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "message-square":
        return (
          <Icon.MessageSquare
            size={20}
            style={{ color: "ed1c24", marginTop: 5 }}
          />
        );
      case "box":
        return <Icon.Box size={20} style={{ color: "ed1c24", marginTop: 5 }} />;
      case "calendar":
        return (
          <Icon.Calendar size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "camera":
        return (
          <Icon.Camera size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "chrome":
        return (
          <Icon.Chrome size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "shopping-cart":
        return (
          <Icon.ShoppingCart
            size={20}
            style={{ color: "ed1c24", marginTop: 5 }}
          />
        );
      case "command":
        return (
          <Icon.Command size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "compass":
        return (
          <Icon.Compass size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "film":
        return (
          <Icon.Film size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "gift":
        return (
          <Icon.Gift size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "github":
        return (
          <Icon.GitHub size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "grid":
        return (
          <Icon.Grid size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "hash":
        return (
          <Icon.Hash size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "headphones":
        return (
          <Icon.Headphones
            size={20}
            style={{ color: "ed1c24", marginTop: 5 }}
          />
        );
      case "heart":
        return (
          <Icon.Heart size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "image":
        return (
          <Icon.Image size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "inbox":
        return (
          <Icon.Inbox size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "info":
        return (
          <Icon.Info size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "map":
        return <Icon.Map size={20} style={{ color: "ed1c24", marginTop: 5 }} />;
      case "music":
        return (
          <Icon.Music size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "package":
        return (
          <Icon.Package size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "paperclip":
        return (
          <Icon.Paperclip size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "play-circle":
        return (
          <Icon.PlayCircle
            size={20}
            style={{ color: "ed1c24", marginTop: 5 }}
          />
        );
      case "radio":
        return (
          <Icon.Radio size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "rss":
        return <Icon.Rss size={20} style={{ color: "ed1c24", marginTop: 5 }} />;
      case "save":
        return (
          <Icon.Save size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "shield":
        return (
          <Icon.Shield size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "slack":
        return (
          <Icon.Slack size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "smartphone":
        return (
          <Icon.Smartphone
            size={20}
            style={{ color: "ed1c24", marginTop: 5 }}
          />
        );
      case "speaker":
        return (
          <Icon.Speaker size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "star":
        return (
          <Icon.Star size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "sun":
        return <Icon.Sun size={20} style={{ color: "ed1c24", marginTop: 5 }} />;
      case "tablet":
        return (
          <Icon.Tablet size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "tag":
        return <Icon.Tag size={20} style={{ color: "ed1c24", marginTop: 5 }} />;
      case "thumbs-up":
        return (
          <Icon.ThumbsUp size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "thumbs-down":
        return (
          <Icon.ThumbsDown
            size={20}
            style={{ color: "ed1c24", marginTop: 5 }}
          />
        );
      case "truck":
        return (
          <Icon.Truck size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "tv":
        return <Icon.Tv size={20} style={{ color: "ed1c24", marginTop: 5 }} />;
      case "twitter":
        return (
          <Icon.Twitter size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "video":
        return (
          <Icon.Video size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
      case "voicemail":
        return (
          <Icon.Voicemail size={20} style={{ color: "ed1c24", marginTop: 5 }} />
        );
    }
  }

  render() {
    return (
      <div className="app">
        {/*  header 지움
        <div className="header">{this.renderHeader()}</div>
        */}
        <div className="main" style={{ backgroundColor: "black" }}>
          {this.renderNameCard()}
          <div
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            {this.renderImages()}
          </div>
        </div>
        <div className="footer">{this.renderButtons()}</div>
      </div>
    );
  }
}

export default Preview;
